import { defineMessages } from 'react-intl';


export default defineMessages({
    label: {
        id: 'InsCommon.genderMessages.label',
        defaultMessage: 'Sex',
    },
    quicktip: {
        id: 'InsCommon.genderMessages.quicktip',
        defaultMessage: 'Ratehub.ca acknowledges all gender identities and are currently working with our providers to offer options that better represent our users.',
    },
});
